<template>
  <div>
    <ul v-if="shown.length" class="pp-msgs" data-test="pp-followup-list">
      <li v-for="f in shown" :key="f.TaskID" class="pp-fu" data-test="pp-followup-row">
        <div class="pp-fu__main">
          <p class="pp-fu__type">{{ f.TaskTypeDisplayName || 'Follow-up' }}</p>
          <p v-if="f.InitialFollowupNote" class="pp-fu__note">{{ f.InitialFollowupNote }}</p>
          <div class="pp-fu__meta">
            <span class="pp-pill" :class="dueClass(f)" data-test="pp-followup-due">{{ due(f).label }}</span>
            <span v-if="f.Status" class="pp-pill pp-pill--slate">{{ f.Status }}</span>
            <span>{{ attempts(f) }}</span>
            <span v-if="f.EmployeeName">· {{ f.EmployeeName }}</span>
          </div>
        </div>
      </li>
    </ul>
    <p v-else class="pp-empty">No open follow-ups for this patient.</p>
    <div v-if="limit && rows.length > limit" class="pp-more">
      Showing 1–{{ limit }} of {{ rows.length }} ·
      <button type="button" class="pp-textbtn" data-test="pp-followups-all" @click="$emit('view-all')">View all</button>
    </div>
  </div>
</template>

<script>
/**
 * The patient's follow-ups as stacked rows (design 1a): type, the note it was started with, a due
 * pill, its status, attempts and who it is assigned to. Read-only — the Schedule View panel's
 * Follow-ups views and the Overview card's fallback. The Patient Profile page fills the Overview
 * card (and its Follow-ups tab) with the editable section (FollowupsProfileSection) instead.
 *
 * Rows are PATIENT_PROFILE's upcomingFollowups, as-is (TaskID, TaskTypeDisplayName, FollowupDate,
 * InitialFollowupNote, Attempts, Status, EmployeeName, pastDue/dueToday as 'true'/'false').
 *
 * ⛔ No prop named `patNum`, `siteID` or `loading` — mixin.js computeds silently replace them.
 */
import { followupDue } from '@/utils/patientPanel/format';

const DUE_CLASS = { stop: 'pp-pill--stop', past: 'pp-pill--due', today: 'pp-pill--done', date: 'pp-pill--slate' };

export default {
  name: 'FollowupList',

  props: {
    rows: { type: Array, default: () => [] },
    /** Show only the first N (with "Showing 1–N of M · View all"); 0 = all. */
    limit: { type: Number, default: 0 },
    dateFormat: { type: String, default: 'MM/DD/YYYY' },
  },

  computed: {
    shown() {
      return this.limit ? this.rows.slice(0, this.limit) : this.rows;
    },
  },

  methods: {
    due(f) {
      return followupDue(f, this.dateFormat);
    },
    dueClass(f) {
      return DUE_CLASS[this.due(f).kind] || 'pp-pill--slate';
    },
    attempts(f) {
      const n = Number(f && f.Attempts) || 0;
      return `${n} attempt${n === 1 ? '' : 's'}`;
    },
  },
};
</script>
